import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-button',
  template: ` <p-button label="wip" styleClass="w-full" size="small" /> `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyButtonComponent extends FieldType {
  constructor() {
    super();
  }
}
